import { Bento } from "@/components/ui/box";
import { useReadingRegister } from "./use-reading-register";

export function CourseReadings({ courseId, teaching }: { courseId: string; teaching: boolean }) {
  const box = useReadingRegister(courseId, teaching);
  return <Bento id="course-readings-register" journey="reading preparation" boxes={[box]} />;
}
